export interface ColumnMetadata {
  isPinned: boolean
  width: number
  pinned: 'left' | 'right' | null
  isVisible: boolean
  index: number | null
}

export type BaseMetadata = Record<string, any>

export interface LegacyTableMetadata extends BaseMetadata {
  columns: Record<string, ColumnMetadata>
}

export interface TableMetadata extends BaseMetadata {
  version?: string
  settings?: {
    table?: {
      columns?: Record<string, ColumnMetadata>
      [key: string]: any
    }
    [key: string]: any
  }
}

export function migrateLegacyMetadata(metadata: LegacyTableMetadata | TableMetadata): TableMetadata {
  if (metadata.settings?.table?.columns !== undefined)
    return metadata as TableMetadata

  if ('columns' in metadata && metadata.columns) {
    const { columns, ...otherFields } = metadata

    return {
      ...otherFields,
      version: '1.0.0',
      settings: {
        ...metadata.settings,
        table: {
          ...metadata.settings?.table,
          columns,
        },
      },
    }
  }

  return {
    ...metadata,
    version: '1.0.0',
    settings: {
      ...metadata.settings,
      table: {
        ...metadata.settings?.table,
        columns: {},
      },
    },
  }
}

export function getColumnMetadata(metadata: TableMetadata | LegacyTableMetadata, columnId: string): ColumnMetadata | null {
  const migratedMetadata = migrateLegacyMetadata(metadata)
  return migratedMetadata.settings?.table?.columns?.[columnId] || null
}

export function updateColumnMetadata(
  metadata: TableMetadata | LegacyTableMetadata,
  columnId: string,
  columnData: Partial<ColumnMetadata>,
): TableMetadata {
  const migratedMetadata = migrateLegacyMetadata(metadata)
  const existingColumn = migratedMetadata.settings?.table?.columns?.[columnId] || {}

  return {
    ...migratedMetadata,
    settings: {
      ...migratedMetadata.settings,
      table: {
        ...migratedMetadata.settings?.table,
        columns: {
          ...migratedMetadata.settings?.table?.columns,
          [columnId]: {
            ...existingColumn,
            ...columnData,
          } as ColumnMetadata,
        },
      },
    },
  }
}
